import { Link } from "react-router-dom";
import { useSettings } from "@/hooks/useSiteData";

export const Logo = ({ variant = "dark", className = "h-9", to = "/", testId = "site-logo" }) => {
  const { data: settings } = useSettings();
  const src = variant === "white" ? settings?.logo_white || "/assets/logo_white.png" : settings?.logo || "/assets/logo.png";
  return (
    <Link to={to} className="inline-flex items-center" aria-label="Jonaren Technology home" data-testid={testId}>
      <img src={src} alt="Jonaren Technology" className={`${className} w-auto`} />
    </Link>
  );
};
